<template>
  <pt-fast-loan-audit class="pt-fast-loan-audit__page"></pt-fast-loan-audit>
</template>

<script>
import PtFastLoanAudit from 'cps/new-to-old-audit/pt-fast-loan-audit/withData'
export default {
  name: 'pt-fast-loan-audit__view',
  components: {
    'pt-fast-loan-audit': PtFastLoanAudit
  }
}
</script>
